import {
    Component,
    OnInit,
    OnDestroy,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, ReplaySubject, combineLatest } from 'rxjs';
import {
    map,
    startWith,
    takeWhile,
    tap,
    distinctUntilChanged,
    filter
} from 'rxjs/operators';
import * as fromStore from '../../store/indirect-rate-rule';
import * as fromStructure from '../../store/indirect-rate-structure';
import * as fromCostCenter from '../../store/indirect-rate-cost-center';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { IndirectRateRule } from '../../store/indirect-rate-rule';
import { IStatusMessage } from '../../../shared';
import { IndirectRateCostCenter } from '../../store/indirect-rate-cost-center';
import { CalcType } from '../../../lookups';
import { IndirectRateStructure } from '../../store/indirect-rate-structure';
import { uniqBy } from '../../../shared';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-indirect-rate-rule-container',
    templateUrl: './indirect-rate-rule-container.component.html',
    styleUrls: ['./indirect-rate-rule-container.component.scss'],
    standalone: false
})
export class IndirectRateRuleContainerComponent implements OnInit, OnDestroy {
    rateTypes$: Observable<SelectItem[]>;
    rateStructures$: Observable<fromStructure.IndirectRateStructure[]>;
    costCenters$: Observable<SelectItem[]>;
    rules$: Observable<IndirectRateRule[]>;
    SelectRate = new ReplaySubject<string>(1);
    SelectCostCenter = new ReplaySubject<number>(1);
    private active = true;
    @Input() selectedError: IStatusMessage;
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    constructor(
        private store: Store<fromStore.State>,
        private log: LoggingService
    ) {}

    ngOnInit() {
        this.store.dispatch(fromStructure.getIndirectRateTypes());

        this.rateTypes$ = this.store.pipe(
            select(fromStructure.selectAll),
            startWith([{}] as IndirectRateStructure[]),
            filter(x => !!x && x.length > 0),
            map(rates =>
                uniqBy(rates, x => x.Calctype).map(x => ({
                    label: x.Calcshortdesc,
                    value: x.Calctype
                }))
            )
        );

        this.costCenters$ = this.store.pipe(
            select(fromCostCenter.selectAll),
            startWith([{}] as IndirectRateCostCenter[]),
            filter(x => !!x && x.length > 0),
            map(rates =>
                rates.map(x => ({
                    label: x.Costcenterdesc,
                    value: x.Costcenterid
                }))
            )
        );
        this.rules$ = this.store.pipe(select(fromStore.selectAll));

        combineLatest([this.SelectRate, this.SelectCostCenter])
            .pipe(
                takeWhile(() => this.active),
                filter(([x, y]) => !!x && !!y),
                distinctUntilChanged((x, y) => x[0] === y[0] && x[1] === y[1]),
                tap(([rateType, costCenter]) =>
                    this.log.verbose({
                        type: 'IndirectRateRuleContainerComponent:subscribe',
                        rateType,
                        costCenter
                    })
                )
            )
            .subscribe(([rateType, costCenter]) => {
                this.store.dispatch(
                    fromStore.getIndirectRateRules({ rateType, costCenter })
                );
            });
    }
    ngOnDestroy() {
        this.active = false;
    }
}
